module.exports = __webpack_public_path__ + "static/img/2023年历-2.9c9697f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2023年历-2.jpg
// module id = JD98
// module chunks = 3